import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "config/api.config";
import {
  AcivateReservesData,
  ActivateListParams,
  PackageActivation,
} from "types/activateReserves.types";
import { ValidationErrors } from "types/masterdata.types";

const preparePackageNrs = (data: PackageActivation) => {
  const dynamicPackageNrs: number[] = [];
  Object.keys(data as PackageActivation).forEach((item) => {
    const { amountPerPackage } = (data as PackageActivation)[item];

    Object.keys(amountPerPackage).forEach((packageKey) => {
      const packageNr = Number(packageKey);
      if (dynamicPackageNrs.indexOf(packageNr) === -1) {
        dynamicPackageNrs.push(packageNr);
      }
    });
  });
  return dynamicPackageNrs;
};

export const activateReservesApi = createApi({
  reducerPath: "activateReserves",
  baseQuery: appBaseQuery,
  endpoints: (builder) => ({
    getPackageActivationData: builder.query<AcivateReservesData, void>({
      query: () => ({
        url: "Management/PackageActivationData",
      }),
      transformResponse: (response: PackageActivation) => ({
        initialData: response,
        packageNrs: preparePackageNrs(response),
      }),
    }),
    activateList: builder.mutation<ValidationErrors, ActivateListParams>({
      query: (requestBody) => ({
        method: "POST",
        url: "/Management/ActivateKundensatzList",
        body: requestBody,
      }),
    }),
    activateOutgoingCalls: builder.mutation<ValidationErrors, void>({
      query: () => ({
        method: "POST",
        url: "/Management/ActivateKundensatzListForOutgoingCalls",
        body: undefined,
      }),
    }),
  }),
});

export const {
  useGetPackageActivationDataQuery,
  useActivateListMutation,
  useActivateOutgoingCallsMutation,
} = activateReservesApi;
